export default "__VITE_PUBLIC_ASSET__a73522d6__"